import { faCarSide, faClipboardCheck, faUser } from '@fortawesome/free-solid-svg-icons';

export const VEHICLE_STEP_CONFIG = { key: 'vehicle', title: 'Información del vehículo', icon: faCarSide };
export const TAKER_STEP_CONFIG = { key: 'taker', title: 'Información del tomador', icon: faUser };
export const CONFIRMATION_STEP_CONFIG = { key: 'confirmation', title: 'Confirmación de datos', icon: faClipboardCheck };

export const STEPS_CONFIG = [
  VEHICLE_STEP_CONFIG,
  TAKER_STEP_CONFIG,
  CONFIRMATION_STEP_CONFIG,
];